import { DatabaseCode, toDatabaseCode } from "./database-code";
import {LocalizedString} from "../i18n/i18n-types";

export type DispatchNotificationStatus = DatabaseCode & {
  description: LocalizedString
}

const queued: DispatchNotificationStatus = {
  code: "QUEUED",
  displayValue: {
    id: "common.entity.dispatchnotification.status.queued",
    defaultMessage: "Queued",
  },
  description: {
    id: "common.entity.dispatchnotification.status.queued.description",
    defaultMessage: "A notification was created and queued for delivery.",
  },
};

const skipped: DispatchNotificationStatus = {
  code: "SKIPPED",
  displayValue: {
    id: "common.entity.dispatchnotification.status.skipped",
    defaultMessage: "Skipped",
  },
  description: {
    id: "common.entity.dispatchnotification.status.skipped.description",
    defaultMessage: "No notification was sent due to gating rules or eligibility checks.",
  },
};

const failed: DispatchNotificationStatus = {
  code: "FAILED",
  displayValue: {
    id: "common.entity.dispatchnotification.status.failed",
    defaultMessage: "Failed",
  },
  description: {
    id: "common.entity.dispatchnotification.status.failed.description",
    defaultMessage: "Notification creation or enqueue failed due to an internal error.",
  },
};

export const dispatchNotificationStatus = {
  queued,
  skipped,
  failed,
};

export const dispatchNotificationStatuses = Object.values(dispatchNotificationStatus);

export const toDispatchNotificationStatus = (code: string): DispatchNotificationStatus =>
  toDatabaseCode(code, dispatchNotificationStatuses);

export const toDispatchNotificationStatusSafely = (
  code: string | undefined
): DispatchNotificationStatus | undefined =>
  code ? toDatabaseCode(code, dispatchNotificationStatuses) : undefined;
